/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Query from "./../../../Basis/Queries/Query";

export interface LadeProvisionenZuAbrechnungsdatumInput {
    abrechnungsdatum: string;
}

export interface Provision {
    provisionId: string;
    belegId?: string;
    belegMatchcode: string;
    provisionsbetrag: number;
    provisionssatz: number;
    zusatzinformation?: string;
}

export default class LadeProvisionenZuAbrechnungsdatum extends Query<
    Provision[],
    LadeProvisionenZuAbrechnungsdatumInput
> {
    public static readonly queryName = "Belege_LadeProvisionenZuAbrechnungsdatum";

    private static readonly query = gql`
        query ${LadeProvisionenZuAbrechnungsdatum.queryName}($input: ${LadeProvisionenZuAbrechnungsdatum.queryName}) {
            ${LadeProvisionenZuAbrechnungsdatum.queryName}(input: $input) {
                provisionId
                belegId
                belegMatchcode
                provisionsbetrag
                provisionssatz
                zusatzinformation
            }
        }
    `;

    constructor(
        input: LadeProvisionenZuAbrechnungsdatumInput,
        onCompleted: (data: Provision[]) => void
    ) {
        super(
            LadeProvisionenZuAbrechnungsdatum.query,
            onCompleted,
            input
        );
    }

    public get name(): string {
        return LadeProvisionenZuAbrechnungsdatum.queryName;
    }
}
